export default "__VITE_ASSET__179c033e__"